<template>
  <div class="d-flex">
    <course-select-dialog
      v-if="['super_admin', 'education_manager'].includes(role.type) && major"
      :major="major"
      class="mr-2"
    ></course-select-dialog>
    <new-course-dialog
      v-if="['super_admin', 'education_manager'].includes(role.type) && major"
      :major="major"
    ></new-course-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import NewCourseDialog from '@/modules/course/NewCourseDialog'
import CourseSelectDialog from '@/modules/major/courses/CourseSelectorDialog.vue'

export default {
  components: {
    NewCourseDialog,
    CourseSelectDialog
  },
  props: {
    disabled: Boolean,
    selected: { type: Array, default: () => [] },
    major: Object
  },
  computed: {
    ...mapState('auth', ['user', 'role'])
  },
  data() {
    return {
      sending: null
    }
  },
  methods: {
    ...mapActions('majorDetail', ['updateMajor']),
    disableCourse() {
      this.updateCourses(
        this.selected.map(item => {
          return { ...item, status: 'private' }
        })
      )
    },
    enableCourse() {
      this.updateCourses(
        this.selected.map(item => {
          return { ...item, status: 'public' }
        })
      )
    },
    onRemove() {
      this.$dialog.confirm({
        title: 'Xóa khỏi chuyên ngành',
        text: `Bạn có muốn bỏ khóa học này ra khỏi chuyên ngành ${this.major.title}?`,
        okText: 'Yes',
        cancelText: 'No',
        done: async () => {
          await this.updateMajor({
            id: this.major.id,
            courses: this.major.courses.filter(course => {
              return this.selected.findIndex(i => i.id !== course.id) >= 0
            })
          })
          this.$emit('onRemove')
        }
      })
    }
  }
}
</script>
